export { Button, type ButtonProps } from "./Button.component";
